export const CREATE_PAGE_PROGRESS_MAP = 'CREATE_PAGE_PROGRESS_MAP';
export const UPDATE_PAGE_PROGRESS = 'UPDATE_PAGE_PROGRESS';
export const GO_TO_PAGE_APPLICATION = 'GO_TO_PAGE_APPLICATION';
export const REVIEW_APPLICATION_PAGE = 'REVIEW_APPLICATION_PAGE';

export interface ProgressMap {
  [key: number]: {
    fields: ObjectKeyStringKeyValues;
    percentComplete: number;
    visited?: boolean;
  };
}

export interface ApplicationFormState {
  pageNumber: number;
  progressMap: ProgressMap;
  reviewingApplication: boolean;
  values: ObjectKeyStringKeyValues;
}

export interface CreatePageProgressMapAction {
  type: typeof CREATE_PAGE_PROGRESS_MAP;
  resetPageProgress: boolean;
  pageFieldsIds: string[];
}

export interface UpdatePageProgressAction {
  type: typeof UPDATE_PAGE_PROGRESS;
  formSyncErrors: any;
  pageNumber: number;
}

export interface NavigateToPageApplicationAction {
  type: typeof GO_TO_PAGE_APPLICATION;
  pageNumber: number;
}

export interface ReviewApplicationPageAction {
  type: typeof REVIEW_APPLICATION_PAGE;
  values: ObjectKeyStringKeyValues;
}

export type ApplicationFormActionTypes =
  | CreatePageProgressMapAction
  | UpdatePageProgressAction
  | NavigateToPageApplicationAction
  | ReviewApplicationPageAction;
